import React, { useContext, useEffect, useCallback } from 'react';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import { useValidation } from 'gw-portals-validation-react';
import { fnolCommonMessages } from 'gw-capability-fnol-common-react';
import { WizardPage, wizardProps, WizardPageTemplate } from 'gw-portals-wizard-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './RepairFacilityPage.metadata.json5';

function FNOLPARepairFacilityPage(props) {
    const translator = useContext(TranslatorContext);
    const { wizardData: claimVM, updateWizardData } = props;
    const {
        isComponentValid,
        initialValidation,
        onValidate,
        registerInitialComponentValidation
    } = useValidation('RepairFacilityPage');

    useEffect(() => {
        if (_.isEmpty(claimVM.value.lobs.personalAuto.repairOption.repairFacility)) {
            const repairFacilityContact = claimVM.value.createContact({
                subtype: 'AutoRepairShop'
            });
            repairFacilityContact.initializePrimaryAddress();
            _.set(
                claimVM.value,
                'lobs.personalAuto.repairOption.repairFacility',
                repairFacilityContact
            );
            updateWizardData(claimVM);
        }
    }, [claimVM, updateWizardData]);

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            showOptional: true
        }
    };

    const shouldPageSkip = useCallback(() => {
        const repairOption = _.get(
            claimVM.value,
            'lobs.personalAuto.repairOption.repairFacility.contactName'
        );
        return !_.isEmpty(repairOption);
    }, [claimVM]);

    useEffect(() => {
        registerInitialComponentValidation(shouldPageSkip);
    }, [registerInitialComponentValidation, shouldPageSkip]);

    return (
        <WizardPage
            cancelLabel={translator(fnolCommonMessages.fnolSaveandExit)}
            skipWhen={initialValidation}
            disableNext={!isComponentValid}
            template={WizardPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                onModelChange={updateWizardData}
            />
        </WizardPage>
    );
}

FNOLPARepairFacilityPage.propTypes = wizardProps;
export default FNOLPARepairFacilityPage;
